<nav class="navbar navbar-expand-md navbar-dark bg-dark">
  <span class="navbar-brand">
    <img src="/assets/logo.png" height="30" class="d-inline-block align-top" alt="">
    Admin
  </span>
  <button
    class="navbar-toggler"
    type="button"
    data-toggle="collapse"
    data-target="#navbarNav"
    aria-controls="navbarNav"
    aria-expanded="false"
    aria-label="Toggle navigation"
  >
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse" id="navbarNav">
    <ul class="navbar-nav ml-3">
      <li class="nav-item">
        <a class="nav-link" routerLink="./impersonate" routerLinkActive="active">Impersonate</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLink="./payments" routerLinkActive="active">Payments</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLink="./edit-merchant" routerLinkActive="active">Edit Merchant</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLink="./notifications" routerLinkActive="active">Notifications</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLink="./delete-accounts" routerLinkActive="active">Delete Accounts</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLink="./qrcodes" routerLinkActive="active">Generate QRcodes</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLink="./sms-logs" routerLinkActive="active">SMS Logs</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLink="./marketing-modal" routerLinkActive="active">Automatic Campaigns</a>
      </li>
    </ul>
  </div>
</nav>

<div class="container p-4">
  <router-outlet></router-outlet>
</div>
